
import { configureStore } from '@reduxjs/toolkit'

import designerPropertiesReducer from "./designerPropertiesSlice";

export default configureStore({
  reducer: {
    properties: designerPropertiesReducer
  },
})
